<template>
  <div class="px-4 py-3 flex items-center justify-between sm:px-6" v-if="max > 0">
    <div class="flex-1 flex justify-between sm:hidden" v-show="max > 1">
      <button
        :disabled="disabled || modelValue <= 1"
        @click.prevent="onUpdate(Number(modelValue) - 1)"
        :class="{
          'hover:bg-gray-50': !disabled && modelValue > 1,
          'bg-gray-50': disabled,
          'bg-white': !disabled,
        }"
        class="relative inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700"
      >
        Previous
      </button>
      <button
        :disabled="disabled || modelValue >= max"
        @click.prevent="onUpdate(Number(modelValue) + 1)"
        :class="{
          'hover:bg-gray-50': !disabled && modelValue < max,
          'bg-gray-50': disabled,
          'bg-white': !disabled,
        }"
        class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700"
      >
        Next
      </button>
    </div>
    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
      <div>
        <p class="text-sm text-gray-700">
          <span class="font-medium">{{ count > 0 ? offset + 1 : 0 }}</span>
          -
          <span class="font-medium">{{ count > 0 ? Math.min(count, offset + limit) : 0 }}</span>
          sur
          <span class="font-medium">{{ count }}</span>
        </p>
      </div>
      <div>
        <nav
          class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px gap-2"
          aria-label="Pagination"
          v-show="max > 1"
        >
          <button
            :disabled="disabled || modelValue <= 1"
            @click.prevent="onUpdate(Number(modelValue) - 1)"
            :class="{
              'hover:bg-gray-50': !disabled && modelValue > 1,
              'bg-gray-50': disabled,
              'bg-white': !disabled,
            }"
            class="relative flex items-center justify-center px-2 py-2 rounded-l-md border border-gray-300 text-sm font-medium text-gray-500"
          >
            <i class="fas fa-arrow-left h-5 w-5 flex justify-center items-center" aria-hidden="true"></i>
            <span class="sr-only">Previous</span>
          </button>

          <select
            :key="modelValue"
            :value="modelValue"
            @input="$event => onUpdate($event.target.value)"
            class="relative inline-flex items-center px-4 py-2 border text-md font-medium rpounded pr-6"
          >
            <option
              v-for="p in max"
              :key="p"
              aria-current="page"
              :disabled="disabled"
              :class="{
                'z-10 bg-indigo-50 border-indigo-500 text-indigo-600': !disabled && modelValue == p,
                'bg-white border-gray-300 text-gray-500': modelValue != p,
                'hover:bg-gray-50': modelValue != p && !disabled,
              }"
              :value="p"
              class="relative inline-flex items-center px-8 py-2 border text-sm font-medium"
            >
              Page {{ p }}
            </option>
          </select>
          <button
            :disabled="disabled || modelValue >= max"
            @click.prevent="onUpdate(Number(modelValue) + 1)"
            class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 text-sm font-medium text-gray-500"
            :class="{
              'hover:bg-gray-50': !disabled && modelValue < max,
              'bg-gray-50': disabled,
              'bg-white': !disabled,
            }"
          >
            <span class="sr-only">Next</span>
            <i class="fas fa-arrow-right h-5 w-5 flex justify-center items-center" aria-hidden="true"></i>
          </button>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default {
  props: {
    modelValue: [String, Number],
    offset: [String, Number],
    limit: [String, Number],
    count: [String, Number],
    disableTime: {
      type: [Number, String],
      default: 0,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const route = useRoute()
    const router = useRouter()
    const disabled = ref(false)
    const max = computed(() => Math.ceil(props.count / props.limit))
    const setRouteQuery = () => {
      const pageStr = String(props.modelValue)
      if (route.query.page !== pageStr) {
        router.replace({ query: { page: pageStr } })
      }
    }
    const onUpdate = page => {
      emit('update:modelValue', page)
      if (props.disableTime > 0) {
        disabled.value = true
        setTimeout(() => {
          disabled.value = false
        }, Number(props.disableTime))
      }
    }
    setRouteQuery()
    watch(() => props.modelValue, setRouteQuery)
    watch(
      () => props.count,
      () => {
        if (props.modelValue > max.value) {
          onUpdate(1)
        }
      },
    )
    return { max, disabled, onUpdate }
  },
}
</script>
